<template>
  <v-layout
    :style="{ 'background-color': BGColor }"
    style="height:100%;width:100%;"
    wrap
  >
    <v-card :color="BGColor" style="width:100%;">
      <!--v-btn
          text
          x-small
          absolute
          top
          right
          :color="Color"
          @click="dialog = false"
          style="margin-right: -15px !important;margin-top: 0px;"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn-->
        <center><v-icon style="margin-top: 30px;font-size:90px !important;" :style="{ 'color': Color}">mdi-account-circle</v-icon></center>
        <!-- <center style="margin-top:10px;margin-bottom:20px;"><h3 style="font-weight:400;" :style="{ 'color': Color}">{{$t('customAuth.guestAccess').toUpperCase()}}</h3></center>         -->
        <v-layout wrap>
          <v-flex xs12>
          <center><h4 :style="{ 'color': Color}">{{$t('users.password', locale)}}</h4></center>
          </v-flex>
          <v-flex xs12>
          <v-text-field
            v-model="password"
            type="password"
            solo
            style="margin: 5px 10px 0;"
            :color="Color"
            v-on:keyup="handleEnter"
          />
          </v-flex>
          <v-flex xs12>
          <center><h4 :style="{ 'color': Color}">{{$t('users.repeatPassword', locale)}}</h4></center>
          </v-flex>
          <v-flex xs12>
          <v-text-field
            v-model="confirmPassword"
            type="password"
            solo
            style="margin: 5px 10px 0;"
            :color="Color"
            v-on:keyup="handleEnter"
          />
          </v-flex>
        </v-layout>
        <v-card-text style="margin-top:10px;height: 300px;">
          <v-alert v-if="message" dense outlined color="red">
            {{message}}
          </v-alert>
          <v-layout wrap style="padding: 5px">
            <v-flex xs12>
            <v-btn :disabled="loading" :color="Color" outlined block @click.stop.prevent="handleChangePass">{{$t('common.ok', locale)}}</v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
  </v-layout>
</template>
<script>
  import axios from 'axios'
  import * as sha1 from 'js-sha1'
export default {
  data () {
    return {
      loading: false, 
      message: '',
      password: '',
      confirmPassword: '',
    }
  },
  computed: {
    token () {
      return this.$route.params.token
      // return 'aaa'
    },
    locale () {
      return this.$store.state.app.locale
    },
    BGColor () {
      return this.$store.state.app.BGColor
    },
    Color() {
      return this.$store.state.app.Color
    },
  },
  methods: {
    handleEnter () {
      //if (this.password.length > 0 && this.confirmPassword.length > 0) this.handleChangePass()
    },
    handleChangePass () {
      if (this.password.length > 0 && this.password === this.confirmPassword) {
        this.message = ''
        axios.post(`${process.env.VUE_APP_API_URL_DFILES}/external/customers/change-pass?token=${this.token}`, { password: sha1(this.password) })
        .then(response => {
          if (response.data.status === 'ok') this.$router.push('/')
          else this.message = 'error'
        })
        .catch(error => {
          this.message = 'error'
        })
      } else this.message = this.$t('users.messages.passwordMatch', this.locale)
    },
  }
}
</script>
